import { render, staticRenderFns } from "./TemaPreset.vue?vue&type=template&id=6b97b339&scoped=true"
import script from "./TemaPreset.vue?vue&type=script&lang=js"
export * from "./TemaPreset.vue?vue&type=script&lang=js"
import style0 from "./TemaPreset.vue?vue&type=style&index=0&id=6b97b339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97b339",
  null
  
)

export default component.exports